import Vue from 'vue';
import VueRouter from 'vue-router';
import qs from 'qs';
import store from '../store';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    redirect: { name: 'Labs' },
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/Login.vue'),
    meta: {
      noAuth: true,
    },
  },
  {
    path: '/register',
    name: 'Register',
    component: () => import('../views/Register.vue'),
    meta: {
      noAuth: true,
    },
  },
  {
    path: '/verified',
    name: 'Verified',
    component: () => import('../views/EmailVerified.vue'),
    meta: {
      noAuth: true,
    },
  },
  {
    path: '/new_password',
    name: 'NewPassword',
    component: () => import('../views/NewPassword.vue'),
    meta: {
      noAuth: true,
    },
  },
  {
    path: '/reset_password',
    name: 'ResetPassword',
    component: () => import('../views/ResetPassword.vue'),
    meta: {
      noAuth: true,
    },
  },
  {
    path: '/password',
    name: 'Password',
    component: () => import('../views/ChangePassword.vue'),
  },
  {
    path: '/labs',
    name: 'Labs',
    component: () => import('../views/Labs.vue'),
  },
  {
    path: '/downloads',
    name: 'Downloads',
    component: () => import('../views/Downloads.vue'),
    meta: {
      noAuth: true,
    },
  },
  {
    path: '/activities/:activity?',
    name: 'Activities',
    component: () => import('../views/Activities.vue'),
  },
  {
    path: '/license',
    name: 'License',
    component: () => import('../views/License.vue'),
  },
  {
    path: '/purchased',
    name: 'Purchased',
    component: () => import('../views/LicensePurchased.vue'),
    meta: {
      noAuth: true,
    },
  },
];

const router = new VueRouter({
  routes,
  parseQuery(query) {
    return qs.parse(query);
  },
  stringifyQuery(query) {
    const result = qs.stringify(query, { encode: false });
    return result ? (`?${result}`) : '';
  },
});

router.beforeEach((to, from, next) => {
  if (!to.matched.some((record) => record.meta.noAuth)) {
    if (!store.getters.loggedIn) {
      next({
        path: '/login',
      });
    } else {
      next();
    }
  } else {
    next();
  }
});

export default router;
